// extracted by mini-css-extract-plugin
module.exports = {"wrap":"_b8362977","itemId":"_a24b203b"};